// import { isPhone } from './base-init'
import { setCookie } from './cookie.js'
import { getCookie } from './cookie.js'

// import ieDetect from './ie-detect'
import detectMobileWidth from './detectMobileWidth'
import getUrlSearchParams from './getUrlSearchParams'


export function submitTarget(
  modelhelper: boolean,
  notCookieCustomer: boolean
) {
  if (modelhelper) {
    if (notCookieCustomer) {
      window.location.href =
        '/store/order/guest-checkout-start?next=/store/order-helper-manager/fast-payment'
    } else {
      let url = '/store/order-helper-manager/fast-payment'
      if (getUrlSearchParams('prevNum')) {
        url += `/prevNum/${getUrlSearchParams('prevNum')}`
      }
      window.location.href = url
    }
  } else if (window.myvars.onePageCheckout) {
    window.location.href = '/store/checkout'
  } else {
    const isMobileWidth = detectMobileWidth()
    setCookie('giftCardCheckout', 0, 1, '')
    if (getUrlSearchParams('mobileOnePage') === '1' && isMobileWidth) {
      window.location.href = `/store/order/fast-payment-one-page/user/${window.myvars.visitUniqueNum}`
    } else if (getUrlSearchParams('mobileOnePage') === '0') {
      window.location.href = '/store/order/review-cart'
    } else if (window.myvars.mobileOnePageCheckout && isMobileWidth) {
      if (getCookie('choiceSeat') == "fromBundle")
        window.location.href = `/store/order/review-cart`
      else
        window.location.href = `/store/order/fast-payment-one-page/user/${window.myvars.visitUniqueNum}`
    } else {
      window.location.href = '/store/order/review-cart'
    }
  }
}

export default submitTarget
